import { safeLessonNoteHref, type LessonNotePart } from "./notes.js";
import { safeExternalResourceUrl } from "./resources.js";

const familyLessonAttachmentHref = /^\/api\/me\/students\/[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}\/lessons\/[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}\/attachments\/[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}$/i;

function safeHubInboxHref(href: string): boolean {
  return safeLessonNoteHref(href)
    || /^\/api\/files\/(?:resource|school-resource|lesson|school)\/[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}\/open$/i.test(href)
    || familyLessonAttachmentHref.test(href);
}

export function safeInboxHref(href: string): boolean {
  return safeHubInboxHref(href) || /^https?:\/\//i.test(href) && safeExternalResourceUrl(href) !== null;
}

export function inboxLink(title: string, href: string): string {
  if (!safeInboxHref(href)) throw new Error("Choose a valid Hub or web link.");
  if (!safeHubInboxHref(href)) return href;
  return `[${title.replace(/[\r\n]+/g, " ").replace(/[\\\[\]]/g, "\\$&")}](${href})`;
}

/** Render plain text and a small safe link vocabulary; never interpret HTML. */
export function inboxMessageParts(body: string): LessonNotePart[] {
  const parts: LessonNotePart[] = [];
  function plain(text: string) {
    let start = 0;
    for (const match of text.matchAll(/https?:\/\/[^\s<>"`]+/gi)) {
      let href = match[0].replace(/[.,!?;:]+$/, "");
      while (href.endsWith(")") && (href.match(/\)/g)?.length ?? 0) > (href.match(/\(/g)?.length ?? 0)) href = href.slice(0, -1);
      if (!safeInboxHref(href)) continue;
      if (match.index! > start) parts.push({ text: text.slice(start, match.index) });
      parts.push({ text: href, href });
      start = match.index! + href.length;
    }
    if (start < text.length) parts.push({ text: text.slice(start) });
  }
  let start = 0;
  for (const match of body.matchAll(/\[((?:\\.|[^\]\\\n])*)\]\(([^\s()]+)\)/g)) {
    if (!safeHubInboxHref(match[2]!)) continue;
    plain(body.slice(start, match.index));
    parts.push({ text: match[1]!.replace(/\\([\\\[\]])/g, "$1"), href: match[2]! });
    start = match.index! + match[0].length;
  }
  plain(body.slice(start));
  return parts;
}
